import type { FaireProductEntity } from "../../entity_types/product";

export const p_89vgzmfa27: FaireProductEntity = {
  token: "p_89vgzmfa27",
  type: "product",
  name: "Ladies Ankle Bamboo Socks, Assorted Prints",
  brandToken: "b_b4vrxv58sb",
  brandName: "Blue Sky Clothing Co LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/d5036a7187e7022e12d0199d07888ba5a4bcc7fe75f47e06ab79978b4bf399a4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1e392161d0b344f727198c7d2232032050cbb0f6cb660e32bf30b209be08c74b.jpeg",
    "https://cdn.faire.com/fastly/3284b38651b21a9640aeb5bbfd6cd6eed12570797bac728caf1190b60ea9e497.jpeg",
    "https://cdn.faire.com/fastly/e7aa960315377bc07bc0fb965e3719ec9c922e4d3064e7bfa8aa991895550b19.jpeg",
    "https://cdn.faire.com/fastly/1eaddea7537ff775768242be3d3c591b637f61c5e2347b0a74582647fb83411f.jpeg",
    "https://cdn.faire.com/fastly/95c2a6222f292611f05dcb43145070f55da82bedca1e200c0e38f547ad9423a4.jpeg",
    "https://cdn.faire.com/fastly/3a2bfb465b3a44f223bc90410d9acc55e52e971cd3e24f1dbf192a456e05ed12.jpeg",
    "https://cdn.faire.com/fastly/f22a4de7749708ef873720624f64a85aac89a60ff90ecaddf77c003775257eae.jpeg",
    "https://cdn.faire.com/fastly/538222244be561a36c8787fd567e90a9b19018ff53c0c28dad908f56af1b19e1.jpeg",
    "https://cdn.faire.com/fastly/1410944a9cf536b70472e50a00715cae6e9b82bfc83849d2380f26c4a1ca5d98.jpeg",
    "https://cdn.faire.com/fastly/a6f8e868feec9ff5ff763f34b65592b391e3f56f0859878fcd6b6f0b885374c2.jpeg",
    "https://cdn.faire.com/fastly/c73e2e98096470d4cd19410401eb64a596c80a6f06279c8f5282d3a21f02e072.jpeg",
    "https://cdn.faire.com/fastly/91896070c08801c014f8ba264811c99648e09d7285fcf1337b916187d4fc0351.jpeg",
    "https://cdn.faire.com/fastly/eeea0e10fb59aa29dcffdaf670947c1aedb483dad0d0d363a7bbc1178067b5e1.jpeg",
  ],
  priceDollars: 1.99,
  description:
    "𝐃𝐞𝐬𝐜𝐫𝐢𝐩𝐭𝐢𝐨𝐧\n\nSocks to match with your outfit! Made with bamboo fibres providing softness, breathability, and moisture-wicking properties to keep feet feeling dry and refreshed.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• Moisture-Wicking\n• Elastic Band\n• Soft Bamboo\n\nFabric - 75% bamboo, 20% rayon, 5% Lycra",
  tags: [],
  msrpDollars: 3.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:44.630Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
